<template>
  <div class="takecash">
    <header class="takecash-top">
      <div>
        <i class="iconfont icon-jifen" aria-hidden="true" style="font-size: 70px; color: #1aad19;"></i>
      </div>
      <p class="takecash-total">
        <span>可提现积分：{{score}}</span>
      </p>
      <p style="margin-top: 10px;" @click="scoreToMoneyList">
        <a href="javascript:;" style="color: blue;">查看提现记录 &gt;&gt;</a>
      </p>
    </header>
    <section class="takecash-main">
      <section class="mail-tips">
        <span style="font-size:14px; font-weight: bold;">积分提现须知</span>
        <p style="font-size:12px;">每10个活跃积分可以提现{{tenScoreCanChange}}分钱，每次至少提现10个积分。</p>
      </section>
      <div class="weui-cells weui-cells_form" style="margin-top: 0px;">
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__hd">
            <label class="weui-label">我要提现</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" placeholder="请输入提现积分" v-model="takecash" style="text-align: right;" />
          </div>
          <div class="weui-cell__ft">
            <button class="weui-vcode-btn">
              <font>积分</font>
            </button>
          </div>
        </div>
      </div>

      <div class="footer-item able" style="flex:2" v-if="score>0" @click="change">
        <a href="javascript:;">立即提现</a>
      </div>
      <div class="footer-item disable" style="flex:2" v-if="score==0">
        <a href="javascript:;">立即提现</a>
      </div>

      <div class="weui-footer">
        <p class="weui-footer__links">
          <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
        </p>
        <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
      </div>
    </section>
  </div>
</template>
<script>
import moment from "moment";
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      score: 0,
      takecash: "",
      tenScoreCanChange: '',
      encodeToken: "",
      token: "",
      year: moment().format("YYYY")
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    this.tenScoreCanChange = 10 * config.scoreToMoneyPercent;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        let userInfo = response.data.data;
        if (userInfo.activeScore) {
          this.score = userInfo.activeScore;
        }
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    scoreToMoneyList() {
      this.$router.push("/moneyDetail/4/" + this.encodeToken);
    },
    change() {
      if (!this.takecash || this.takecash<10) {
        weui.alert("提现积分必须>=10");
        return;
      } else if (this.takecash > this.score) {
        weui.alert("对不起，您只有"+this.score+"积可提现");
        return;
      }

      axios
        .put("/api/money/scoreToMoney/" + this.takecash)
        .then(res => {
          if (res.data.success) {
            weui.toast("提现成功", 1000);
            this.score -= this.takecash;
            this.takecash = '';
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          weui.alert("提现失败");
        });
    }
  }
};
</script>
<style scoped>
.takecash {
  margin-top: 40px;
  font-size: 16px;
}
.takecash-top {
  text-align: center;
}
.takecash-top .fa-money {
  font-size: 90px;
}
.takecash-total {
  font-size: 24px;
  color: gold;
}
.takecash-main {
  margin-top: 30px;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  line-height: 50px;
}
.footer-item.able {
  background-color: #1aad19;
}
.footer-item.disable {
  background-color: grey;
}
.footer-item a {
  color: #ffffff;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.weui-label {
  width: auto !important;
}
</style>




// WEBPACK FOOTER //
// src/components/operations/ScoreToMoney.vue